import React, { useState } from 'react';
import { Image, ScrollView, StyleSheet, View } from 'react-native';
import { Button, Input, Text, useTheme } from '@rneui/themed';
import { useAuth } from '../hooks/useAuth';
import { useFirestore } from '../hooks/useFirestore';
import OkDialog from '../components/OkDialog';
import PasswordInput from '../components/PasswordInput';

const SignUpScreen = ({ navigation }) => {
  const { theme } = useTheme();
  const { createUserWithEmailAndPassword, validateEmail } = useAuth();
  const { createUserDoc } = useFirestore();
  const [email, setEmail] = useState({ value: '', valid: false });
  const [password, setPassword] = useState({
    value: '',
    valid: false,
    show: false,
  });
  const [sending, setSending] = useState();
  const [sentDialogVisible, setSentDialogVisible] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);

  const onSignUp = async () => {
    try {
      setSending(true);
      const userCredential = await createUserWithEmailAndPassword(
        email.value,
        password.value
      );
      await createUserDoc(userCredential.user);
      setSentDialogVisible(true);
    } catch (error) {
      console.log('*** error', error);
      setErrorDialogVisible(true);
    } finally {
      setSending(false);
    }
  };

  const onEmailChanged = (value) => {
    setEmail({ value, valid: validateEmail(value) });
  };

  const onPasswordChanged = (value) => {
    if (value.length >= 6) {
      setPassword({ ...password, value, valid: true });
    } else {
      setPassword({ ...password, value, valid: false });
    }
  };

  return (
    <ScrollView contentContainerStyle={styles.contentContainer}>
      <View style={styles.container}>
        <View style={{ rowGap: 25, marginBottom: 50 }}>
          <OkDialog
            title="Användare skapad!"
            body="Vi har skickat en länk till din e-post som du måste klicka på för att verifiera att du vill använda Glasklart."
            visible={sentDialogVisible}
            onOkPress={() => {
              setSentDialogVisible(false);
              navigation.goBack();
            }}
          />
          <OkDialog
            title="Kunde inte skapa användare"
            body={`Användare för ${email.value} kunde inte skapas. Kontrollera din uppkoppling eller att du inte redan har skapat en användare.`}
            visible={errorDialogVisible}
            onOkPress={() => setErrorDialogVisible(false)}
          />
          <View style={styles.headerContainer}>
            <Text h1 style={[styles.text, { color: theme.colors.primary }]}>
              Glasklart
            </Text>
          </View>
          <View style={styles.logoContainer}>
            <Image
              style={styles.logoImage}
              source={require('../../assets/icon.png')}
            />
          </View>
        </View>

        <View style={{ rowGap: 35 }}>
          <View style={styles.textView}>
            <Text h3>Din e-post blir ditt användarnamn</Text>
          </View>

          <View style={{ rowGap: 10 }}>
            <Input
              keyboardType="email-address"
              placeholder="Tryck för att skriva e-post"
              placeholderTextColor="lightgrey"
              onChangeText={onEmailChanged}
              value={email.value}
              errorMessage={email.valid ? null : 'Ange en korrekt e-postadress'}
            />
            <PasswordInput
              style={styles.input}
              placeholder="Lösenord"
              onChangeText={onPasswordChanged}
              value={password.value}
              showStrength
              iconColor={theme.colors.primary}
              errorMessage={password.valid ? null : 'Minst 6 tecken'}
            />
          </View>
          <View style={{ rowGap: 10 }}>
            <Button
              title="Skapa användare"
              onPress={onSignUp}
              disabled={sending || !email.valid || !password.valid}
              disabledStyle={{
                backgroundColor: theme.colors.primaryTrans,
              }}
              disabledTitleStyle={{ color: 'lightgrey' }}
              loading={sending}
            />
            <Button
              title="Avbryt"
              type="outline"
              onPress={() => navigation.goBack()}
            />
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    paddingHorizontal: 16,
    paddingVertical: 30,
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 20,
  },
  logoContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoImage: {
    width: 192,
    height: 192,
  },
  textView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 20,
  },
  button: {
    marginBottom: 20,
  },
  text: {
    textAlign: 'center',
  },
});

export default SignUpScreen;
